import { Box, FormControl, Grid, IconButton, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { get_ODS } from "../services/api";
import { useProyecto } from '../data/ProyectoContext';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export default function GetODS({ onODSChange }) {

    const [data, setData] = useState([])
    const [selectedODS, setSelectedODS] = useState('')
    const [selectedODSChips, setSelectedODSChips] = useState([])
    const { proyecto, setProyecto } = useProyecto();

    useEffect(() => {
        async function ObtenerDatosDeAPI() {
            try {
                // Realiza la solicitud GET a la URL de la API
                const { data, status } = await get_ODS();

                // Verifica si la solicitud fue exitosa
                if (status === 200) {
                    // La respuesta de la API se encuentra en response.data
                    const datos = data;
                    const odsArray = Object.entries(datos).map(([nombre, id]) => ({
                        nombre,
                        id,
                    }));
                    setData(odsArray)

                    // Imprime los datos en la consola en formato JSON

                    //console.log(JSON.stringify(datos, null, 2));
                } else {
                    console.error('La solicitud a la API no fue exitosa.');
                }
            } catch (error) {
                console.error('Se produjo un error al realizar la solicitud a la API:', error);
            }
        }

        ObtenerDatosDeAPI();
    }, [])

    const handleODSChange = (event) => {
        const selectedODS = event.target.value;
        const nameSelectedODS = data.find((ods) => ods.id === selectedODS);

        // Agregar el chip
        setSelectedODSChips((prevChips) => [...prevChips, nameSelectedODS]);
        // Enviar el array completo de ODS seleccionados al componente padre
        onODSChange([...selectedODSChips, selectedODS]);
        setSelectedODS(selectedODS);
        onODSChange(nameSelectedODS);


    }

    //Función para eliminar los ODS seleccionadas
    const handleRemoveODS = (ods) => {
        // Filtra el array del estado del proyecto para eliminar el ODS con el ID correspondiente
        setProyecto((prevProyecto) => ({
            ...prevProyecto,
            ods: prevProyecto.ods.filter((selectedODS) => selectedODS.id !== ods.id),
        }));
    };

    return (
        <Grid item xs={12} sm={12} >
            <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>Objetivos de desarrollo sostenible </Typography>
            </Box>
            <FormControl fullWidth>

                <Select
                    labelId="select-subject"
                    id="select-subject"
                    variant='outlined'
                    value={selectedODS}
                    onChange={handleODSChange}
                    sx={{
                        borderRadius: 2,
                        fontFamily: 'montserrat',
                        mb: 2,
                        fontSize: '14px',
                        color: '#336B87',
                        '& fieldset': { borderColor: 'Divider' },
                        '&:before': { borderColor: 'Divider' },
                        '&:after': { borderColor: 'Divider' }
                    }}
                >
                    {data.map((ods) => (
                        <MenuItem key={ods.id} value={ods.id} sx={{ color: '#005559', fontFamily: 'montserrat', fontSize: '0.8rem' }}
                        >{ods.nombre}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Botón para agregar y quitar un ODS*/}<Grid item xs={12} md={6}  >
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1rem', fontWeight: 'medium', color: '#336B87' }}>Objetivos de desarrollo sostenible seleccionados:</Typography>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                        width: '100%',
                        position: 'relative',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            border: '2px solid transparent',
                            borderRadius: 'inherit',
                            borderImage:
                                'repeating-linear-gradient(90deg, #E7E7E7, #E7E7E7 10px, transparent 10px, transparent 20px) 1',
                            pointerEvents: 'none',
                        },
                    }}
                >
                    {proyecto.ods.map((ods) => (
                        <Box key={ods.id} sx={{ m: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', backgroundColor: 'rgba(51, 107, 135, 0.3)', pl: 1, borderRadius: '5px',  alignItems: 'center', justifyContent: 'space-between', }}>
                                <Typography 
                                    style={{
                                        fontFamily: 'Montserrat',

                                        fontSize: '0.85rem',
                                        display: 'flex',
                                        color: '#336B87',
                                        fontWeight: 'normal',
                                    }} >
                                    {ods.nombre}

                                </Typography>
                                <IconButton
                                    onClick={() => handleRemoveODS(ods)}
                                    sx={{
                                        
                                        color: '#336B87',
                                    }}
                                >
                                    <DeleteForeverIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}
                </Grid>
            </Grid>

        </Grid>
    )

}




/*<TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Nombre</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((modelo) => (
            <TableRow key={modelo.id}>
              <TableCell component="th" scope="row">{modelo.id}</TableCell>
              <TableCell>{modelo.nombre}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer> */